import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type AppLanguage = 'es' | 'en';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly storageKey = 'lang';
  private readonly languageSubject = new BehaviorSubject<AppLanguage>(
    this.getStoredLanguage()
  );

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('storage', (event: StorageEvent) => {
        if (event.key === this.storageKey) {
          this.languageSubject.next(this.sanitizeLanguage(event.newValue));
        }
      });
    }
  }

  get currentLang$(): Observable<AppLanguage> {
    return this.languageSubject.asObservable();
  }

  get currentLang(): AppLanguage {
    return this.languageSubject.value;
  }

  setLanguage(language: AppLanguage): void {
    const sanitizedLanguage = this.sanitizeLanguage(language);
    localStorage.setItem(this.storageKey, sanitizedLanguage);
    this.languageSubject.next(sanitizedLanguage);
  }

  private getStoredLanguage(): AppLanguage {
    return this.sanitizeLanguage(localStorage.getItem(this.storageKey));
  }

  private sanitizeLanguage(language: string | null): AppLanguage {
    return language === 'en' ? 'en' : 'es';
  }
}
